export const rawObject = {
  googl_site_Key_Original: "6LeBO_kkAAAAAMpZW-ONq8wJtXT4G_uhPgVsUWDF",
  googl_site_Key_Demo: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
};
